import { useTranslation } from 'react-i18next';

export const EmptySearchResultsSidebar = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-2 flex items-center justify-center rounded-md bg-gray-50 p-3 text-center text-sm leading-5 font-normal text-gray-500">
      {t('orderForms:form.sidebar.emptySearch')}
    </div>
  );
};
